<template>
  <v-container fluid fill-height>
    <v-container fluid v-if="!loading">
      <ProductsAppBar :products="products" :showLogo="true" :app="true"></ProductsAppBar>
      <v-spacer></v-spacer>
      <v-main>
        <v-tabs-items v-model="activeProductTag" :touchless="true">
          <v-tab-item value="ai_chat" href="ai_chat">
            <AIChatDashboard :initial-clinic="clinic" :initial-account-id="productsMetadata.account_id"></AIChatDashboard>
          </v-tab-item>
          <v-tab-item value="reviews" href="reviews">
            <ReviewsDashboard :initial-clinic="clinic" :ghl-key="ghlKey" :account-id="productsMetadata.account_id"></ReviewsDashboard>
          </v-tab-item>
          <v-tab-item value="website" href="website">
            <WebsitesDashboard :property-key="Number(productsMetadata.ga_property_key)" :property-name="clinic">
            </WebsitesDashboard>
          </v-tab-item>
          <v-tab-item value="webmd" href="webmd">
            <WebMDDashboard :initial-clinic="clinic"></WebMDDashboard>
          </v-tab-item>
          <v-tab-item value="text_to_pay" href="text_to_pay">
            <TextToPayDashboard :initial-clinic="clinic" :ghl-key="ghlKey"></TextToPayDashboard>
          </v-tab-item>
          <v-tab-item value="ai_dialer" href="ai_dialer">
            <AIAutoDialerDashboard :initial-clinic="clinic"></AIAutoDialerDashboard>
          </v-tab-item>
          <v-tab-item value="appointments" href="appointments">
            <AppointmentsDashboard :initial-clinic="clinic" :location-id="ghlKey"></AppointmentsDashboard>
          </v-tab-item>
        </v-tabs-items>
      </v-main>
    </v-container>
    <FullpageProgressBar v-if="loading"/>
  </v-container>
</template>

<script>
import FullpageProgressBar from "@/components/ui/FullpageProgressBar.vue";
import ProductsAppBar from "@/components/appbar/ProductsAppBar.vue";
import DataAPI from "@/utils/DataAPI";
import EventBus from "@/utils/EventBus";
import AIChatDashboard from "@/views/AIChatDashboard.vue";
import ReviewsDashboard from "@/views/ReviewsDashboard.vue";
import WebMDDashboard from "@/views/WebMDDashboard.vue";
import WebsitesDashboard from "@/views/WebsitesDashboard.vue";
import TextToPayDashboard from "@/views/TextToPayDashboard.vue";
import AIAutoDialerDashboard from "@/views/AIAutoDialerDashboard.vue";
import AppointmentsDashboard from "@/views/AppointmentsDashboard.vue";
import { ACTIVE_PRODUCTS } from "@/utils/constants";

/**
 * This component is the main view of the dashboard. It is embedded in the GHL Dashboard and it's responsible for
 * displaying the different view componentes depending on the customer subscribed products.
 *
 * To get data from the backend it uses the class DataAPI. To ensure that the
 * user is logged and check its capabilities it uses the class AuthAPI.
 */

export default {
  name: 'EmbeddedDashboard',
  data: () => ({
    loading: true,
    clinic: "",
    accountId: "",
    ghlKey: "",
    isMobile: false,
    products: [],
    productsMetadata: {
      account_id: "",
      webmd_npi: 0,
      ga_property_key: 0,
      ghl_key: ""
    },
    activeTab: 0,
    activeProductTag: ""
  }),
  async mounted() {
    this.onResize();
    window.addEventListener('resize', this.onResize);

    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    this.accountId = params.get("account_id") || "";
    this.ghlKey = params.get("ghl_key") || "";

    await this.updateData();

    EventBus.$on("products-app-bar-clicked", (product, tabIndex) => {
      console.log(`Customer clicked on tab ${product}, ${tabIndex}`)
      this.activeTab = tabIndex;
      this.activeProductTag = product;
    });
  },
  beforeDestroy() {
    if (this.$intercom) this.$intercom.shutdown();
  },
  methods: {
    async updateData() {
      console.log("Update data with accountId:", this.accountId, "ghlKey:", this.ghlKey);
      this.loading = true;

      try {
        // Use account_id if available, otherwise fall back to ghl_key
        const identifier = this.accountId || this.ghlKey;
        const paramType = this.accountId ? 'account_id' : 'ghl_key';

        const productsConfig = await DataAPI.getActiveProductsByIdentifier(identifier, paramType);
        this.clinic = productsConfig?.clinic ?? "";
        this.products = productsConfig?.products ?? [];
        this.products = this.products.sort();
        this.products = this.products.filter(product => ACTIVE_PRODUCTS.includes(product));
        this.productsMetadata = productsConfig?.metadata ?? {};
        this.activeProductTag = "ai_chat";
      } catch (err) {
        console.error("Failed to load products:", err);
      } finally {
        this.loading = false;
      }
    },
    onResize() {
      this.isMobile = window.innerWidth < 1000;
    }
  },
  components: {
    AppointmentsDashboard,
    AIAutoDialerDashboard,
    WebsitesDashboard,
    WebMDDashboard,
    TextToPayDashboard,
    ReviewsDashboard,
    AIChatDashboard,
    ProductsAppBar,
    FullpageProgressBar
  }
}
</script>
